import React from "react";
import Funders from "../components/Funders";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop";

const Investors = () => {
  document.title = "Our Funders | IQApex Labs";
  return (
    <>
      <Funders />
      <BackToTop />
      <Footer />
    </>
  );
};

export default Investors;
